import request from 'utils/request';
import { TRAVELMODE_WALKING } from './constants';
import decodePath from './decodePath';
import gaTrack from './gaTrack';

function* stadia(waypoints, travelMode, hash) {
  const locations = waypoints.map(pt => ({ lat: pt.lat, lon: pt.lng }));
  const costing = travelMode === TRAVELMODE_WALKING ? 'pedestrian' : 'bicycle';
  const json = { locations, costing, ...hash };
  const jsonString = JSON.stringify(json);
  const url = `https://route.stadiamaps.com/route?json=${jsonString}`;

  const data = yield request(url, {}, gaTrack);

  const dirRoute = data.trip;
  return dirRoute.legs.map(leg => decodePath(leg.shape, 6));
}

export default stadia;
